import React from 'react'

const Placeholder = () => {
    return <div className="icon-wrap icon-wrap-active">
        <div className="placeholder"></div>
    </div>;
}

export default Placeholder